function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { Form } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import Select from 'react-select';

// works if rendered in a component, where the IsUnderReviewContext is provided
export default function ImmutableUnderReviewCompanyFormControl(_ref) {
  let {
    className = '',
    disabled = false,
    ...props
  } = _ref;
  const isAnyCompanyClaimGroupUnderTechnicalReview = useSelector(state => state.review.isAnyCompanyClaimGroupUnderTechnicalReview);
  const isDisabled = disabled || isAnyCompanyClaimGroupUnderTechnicalReview;
  if (props.as === Select) {
    delete props.as;
    return /*#__PURE__*/React.createElement(Select, _extends({
      className: `${className} ${isDisabled ? 'disabled' : ''}`
    }, props, {
      isDisabled: isDisabled
    }));
  }
  return /*#__PURE__*/React.createElement(Form.Control, _extends({
    className: `${className} ${isDisabled ? 'disabled' : ''}`
  }, props, {
    disabled: isDisabled
  }));
}